import { differenceInDays, parse } from "date-fns";
import { NavLink } from "react-router-dom";

import Link from "@/components/Link";
import { PageRoute } from "@/constants/pages";

import Header from "../Header";
import GuestPassGroupCard from "./GuestPassGroupCard";
import { HistoricalGuestPass } from "./GuestPassHistory";

const errorCodeToMessage: Record<string, string> = {
  INVALID_PARENT_COUPON_ID: "Parent coupon code does not exist.",
  INVALID_PARENT_COUPON_TYPE: "Parent coupon code type is not valid.",
  INVITE_CONFIG_DOES_NOT_EXIST: "",
  FREQUENCY_LIMIT_EXCEEDED: "Maximum number of shares reached.",
  INVALID_SMS: "Phone number is not valid.",
  INVALID_EMAIL: "Email is not valid.",
  FAILED_UPDATING_CUSTOMER_INVITE_CONFIG:
    "Failed to update customer invite config.",
};

export const getDaysTillExpiry = (expiresDate: string | undefined) => {
  if (!expiresDate) {
    return null;
  }
  const days = differenceInDays(
    parse(expiresDate, "yyyy-MM-dd", new Date()),
    Date().valueOf(),
  );
  if (days === 0) {
    return "Expires today";
  }
  return `Expires in ${days} day${days > 1 ? "s" : ""}`;
};

export const getErrorMessage = (error: string): string => {
  if (Object.prototype.hasOwnProperty.call(errorCodeToMessage, error)) {
    return errorCodeToMessage[error];
  } else {
    return "An unknown error occurred.";
  }
};

export type GuestPassFaqs = {
  question: string;
  answer: string;
};

export type GuestPass = {
  name: string;
  subText: string;
  expiresDate?: string;
  count: number;
  promoCodeId: number;
  restrictions: string;
  faqs: GuestPassFaqs[];
};

export type CurrentPromotionsProps = {
  passes: GuestPass[];
  passHistory: HistoricalGuestPass[];
};

export default function GuestPasses({
  passes,
  passHistory,
}: CurrentPromotionsProps) {
  const hasPassHistory = passHistory?.length > 0;
  if (passes?.length === 0 && !hasPassHistory) {
    return null;
  }

  return (
    <>
      <div className="mb-4 mt-5 flex items-center justify-between">
        <Header className="text-xl" as="h2">
          Guest Passes
        </Header>
        {hasPassHistory && (
          <Link
            to={PageRoute.GUEST_PASS_HISTORY}
            as={NavLink}
            className="text-right text-xs"
          >
            View History
          </Link>
        )}
      </div>
      <div>
        <GuestPassGroupCard passes={passes} />
      </div>
    </>
  );
}
